import { useCallback, useState } from 'react'
import { apiDelete, apiPost } from 'tennders-stracture/libs/api'
import { useToast } from 'tennders-common/hooks/useToast'
import useTranslation from 'next-translate/useTranslation'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useInputScroll from 'tennders-common/hooks/useInputScroll'
import { get } from 'lodash'

const useMultipleCostInvoiceSave = (props) => {
  const {
    lines,
    discountLines,
    extraCostsLines,
    form,
    invoiceDocuments,
    totalExtraCostsIncVat,
    setFormErrors,
    calculations,
    onClose,
    selectedTransaction
  } = props
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const { toastSuccess, toastError } = useToast()
  const { refreshTransaction } = useTransaction()
  const { scrollToFirstError } = useInputScroll()

  const scrollToTop = () => {
    const elementModal = document.getElementsByClassName('modal')
    if (elementModal?.length) {
      elementModal[0].scrollIntoView({ behavior: 'smooth' })
    }
  }

  const onSuccess = useCallback(() => {
    if (selectedTransaction?.id) {
      refreshTransaction(selectedTransaction?.id)
    }
  }, [selectedTransaction])

  const deleteInvoice = async (id) => {
    setDeleting(true)
    await apiDelete('/costInvoice/' + id, {})
    setDeleting(false)
    toastSuccess(t('costInvoice:invoice_delete_request_sent'))
    onClose()
  }

  const save = async () => {
    setLoading(true)
    let response
    try {
      response = await apiPost('/costInvoice', {
        ...form,
        dueDate: new Date(form.dueDate),
        ...calculations,
        lines,
        discountLines,
        extraCostsLines,
        invoiceDocuments,
        totalExtraCostsIncVat
      })
    } catch (e) {
      response = e?.response?.data?.errors
      if (response && Object.keys(response)) {
        const _errors = response
        if (_errors?.company_id) {
          _errors['invoiceNo'] = _errors.company_id
          toastError(_errors.company_id)
        } else {
          toastError(t('addLoad:checkErrors'))
        }
        setFormErrors(response)
        scrollToFirstError()
        setLoading(false)
        return false
      }
      if (e?.errors) {
        toastError(t('variables:SOMETHING_WENT_WRONG'))
        setLoading(false)
        return false
      }
    }
    setLoading(false)
    if (form.draftId) {
      await apiDelete('/costInvoice/drafts/' + form.draftId)
    }
    return true
  }

  const handleSubmit = useCallback(async () => {
    const result = await save()
    if (result) {
      toastSuccess(t('costInvoice:cost_invoice_saved'))
      setTimeout(() => onSuccess(), 500)
      onClose()
    }
  }, [form.id, save])

  return { save, loading, deleteInvoice, deleting, handleSubmit }
}

export default useMultipleCostInvoiceSave
